type Props = {
  shouldRenderWrapperElement: boolean;
  wrapper(children: JSX.Element): JSX.Element;
  children: JSX.Element;
};

const ConditionalWrapper = ({ shouldRenderWrapperElement, wrapper, children }: Props): JSX.Element =>
  shouldRenderWrapperElement ? wrapper(children) : children;

export default ConditionalWrapper;
